// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Background: #0b0b0c
Iconography and buttons: #42bbd8
Title: #d1d0d1
Headers: #cccdcd
Text: #cdccca 
Card backgrounds: #161717

*/
.ptc-h {
  color: #cccdcd;
}
/* .ptc-card {
  background-color: #161717;
  color: #cdccca
} */

.ptc-button {
  background-color: #42bbd8;
  color: black;
  font-weight: bold;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.ptc-secondary-button {
  background-color: #777;
  color: #111;
  font-weight: bold;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
a {
  color: #42bbd8;
}


h1, h2, h3, h4 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  color: #cccdcd;
}


/*
OLD (up to september 4 2025) Color Palette:
  Violet: #58204b
  Russian Violet: #3f2151
  Cambridge Blue: #8ab0ab
  Dark green: #0e402d
  Gold: #deb841
  Auburn (Red): #9e2a35
  Lime: #ceff1a

*/
/* 

This is too devy:
h1, h2, h3, h4 {
  font-family:'Courier New', Courier, monospace
} */


/* Reset layout */
body {
  margin: 0;
  /* font-family: 'Helvetica Neue', sans-serif; */

  /* Lets make a really cool font family for this personal trainers app */
  /* font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; */
  /* font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif; */

  /* font-family: 'IBM Plex Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif; */

  background-color: #b88080;
  /* color: #1c1c1e; */
  color: #bab7d0;
}

.container {
  display: flex;
  /* min-height: 100%; */
}

.text-dark {
  color: black !important;
}

.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Full viewport height */
}

/* Sidebar bottom links */
.nav-link-sidebar-bottom {
  margin-top: auto !important;
  display: block;
  /* Optional: add a little spacing from the bottom */
  margin-bottom: 0.5rem;
}

/* Ensure sidebar uses flex column for proper alignment */
.sidebar .client-nav {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}


/* Main Content */
.main {
  width: 100%;
  flex: 1 1;
  /* padding: 2rem; */
  /* padding-top: 6rem; */
}


.goal-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.goal-item {
  padding: 1rem;
  border-radius: 10px;
  font-weight: bold;
  font-size: 1.1rem;
  color: #1c1c1e;
}

.goal-0 { background-color: #f78b82; } /* Build Muscle */
.goal-1 { background-color: #fddc64; } /* Lose Fat */
.goal-2 { background-color: #3ec6c0; } /* Improve Endurance */
.goal-3 { background-color: #c7a8f3; } /* Increase Strength */
.goal-4 { background-color: #f7a864; } /* Increase Mobility */

/* Output layout */
.output {
  /* margin-top: 2rem; */
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  color: rgb(153, 170, 255);
  background-color: rgba(0,0,0,0.3);
  border-radius: 10px;
  padding: 1.5rem 0.5rem;
  margin: 1.5rem 0;
}

.day {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}


.calendar-day {
  background-color: #b5eec3; /* Olive green background */
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.copy-link {
  background-color: #8ab0ab; /* Cambridge Blue background */
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.2s;
}
.get-google-sheet-export {
  background-color: #3f2151; /*  background */
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-weight: bold;
  display: inline-block;
  cursor: pointer;
  transition: background-color 0.2s;

}
.exercise {
  background-color: #8ab0ab; /* Cambridge Blue background */
  padding: 0.5rem 1rem;
  margin: 0.2rem 0rem;
  border-radius: 8px;
  font-weight: bold;
  display: inline-block;
  width: 100%;
}

.yellow { background-color: #fddc64; }
.green { background-color: #b5eec3; }
.red    { background-color: #f78b82; }

/* Weaknesses Card */
.weakness {
  background-color: #9E2A35; /* Auburn (red) background */
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* One-rep max input group */
.one-rep-max {
  background-color: #0e402d; /* Evergreen color */
  color: white;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.one-rep-max input[type="number"],
.one-rep-max select {
  height: 120%; /* 20% bigger */
  font-size: 110%; /* 10% bigger */
}

/* Availability Slot */
.availability-slot {
  background-color: #8ab0ab; /* Blue background */
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  position: relative; /* Enable positioning within the slot */
}

.availability-slot h2 {
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 0.5rem;
}

.availability-slot select,
.availability-slot input[type="text"],
.availability-slot input[type="number"] {
  height: 2.5rem;
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.availability-slot select:focus,
.availability-slot input[type="text"]:focus,
.availability-slot input[type="number"]:focus {
  outline: none;
  border-color: #1976d2; /* Darker blue for focus */
}

.availability-slot p{
  margin: 0;
}

.availability-slot .delete-slot {
  position: absolute; /* Position relative to the slot */
  top: 0.5rem; /* Close to the top */
  right: 0.5rem; /* Close to the right */
  background-color: #9e2a35; /* Red background */
  color: white;
  border: none;
  padding: 0.5rem;
  border-radius: 5px;
  font-size: 0.8rem; /* Slightly larger font size */
  cursor: pointer;
  transition: background-color 0.2s;
}

.availability-slot .delete-slot:hover {
  background-color: #9e2a35; /* Darker red on hover */
}

/* Add Another Button */
button.add-another {
  width: 100%;
  background-color: #ceff1a; /* Lime background */
  border: none;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

button.add-another:hover {
  background-color: #0e402d; /* Slightly darker green on hover */
}

button.add-another .icon {
  font-size: 1.2rem; /* Icon size */
}

/* Workout Preferences */
.workout-preferences {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  /* mint green muted  */
  padding: 1.5rem;
}

.workout-preferences input {
  height: 2.5rem;
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

/* Workout Selector */
.workout-selector {
  height: 2.5rem;
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  margin-bottom: 1rem;
}

.workout-selector:focus {
  outline: none;
  border-color: #1976d2; /* Darker blue for focus */
}

/* Week Calendar */
.week-calendar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem; /* Reduce gap further for tighter layout */
  margin-top: 1rem; /* Add margin to push day blocks down */
}

.day-block {
  background-color: #b5eec3; /* Olive green background */
  color: black;
  padding: 0.5rem; /* Reduce padding further */
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(20.2% - 0.5rem); /* Adjust width for seven columns */
  max-width: calc(20.2% - 0.5rem);
}

@media (max-width: 768px) {
  .day-block {
    flex: 1 1 100%; /* Full width for smaller screens */
    max-width: 100%;
  }
}

.day-block h3 {
  font-size: 0.9rem; /* Slightly smaller font size */
  font-weight: bold;
  
  margin-bottom: 0.3rem; /* Reduce margin */
}

.availability-slot button.delete-slot {
  background-color: #9e2a35; /* Red background */
  color: white;
  border: none;
  padding: 0.5rem;
  border-radius: 5px;
  font-size: 0.5rem;

  
  cursor: pointer;
  transition: background-color 0.2s;
}


.card {
  /* background-color: #ffffff; */
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

button.add-slot {
  width: 100%;
  background-color: #ceff1a; /* Green background */
  color: black;
  border: none;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

button.add-slot:hover {
  background-color: #0e402d; /* Slightly darker green on hover */
}

button.add-slot .icon {
  font-size: 1.2rem; /* Icon size */
}

/* Guided View Styles */
.guided-view {
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  padding: 2rem;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.guided-view .quote {
  font-style: italic;
  font-size: 1.2rem;
  color: #666;
  margin: 2rem 0;
}

.guided-view .start-button {
  background-color: #deb841; /* Gold background */
  color: black;
  font-weight: bold;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.guided-view .start-button:hover {
  background-color: #c9a539;
}

.exercise-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.exercise-image img {
  border-radius: 8px;
  max-width: 100%;
}

.exercise-details {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.1rem;
  width: 100%;
  text-align: left;
}

.exercise-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
}

.complete-button, .failed-button {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}

.complete-button {
  background-color: #4caf50; /* Green */
  color: white;
}

.complete-button:hover {
  background-color: #3e8e41;
}

.failed-button {
  background-color: #f44336; /* Red */
  color: white;
}

.failed-button:hover {
  background-color: #d32f2f;
}

.completion h1 {
  color: #4caf50;
  margin-bottom: 1.5rem;
}

/* View switch styles */
.view-switch {
  display: flex;
  gap: 1.5rem;
  /* margin-bottom: 2rem; */
  /* background-color: #f5f5f5; */
  padding: 1rem;
  border-radius: 8px;
}

.view-switch label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
}

.view-switch input[type="radio"] {
  cursor: pointer;
}

/* Modifies react-big-calendar styles */
.calendar-container {
  color: white; 
}
.rbc-toolbar button {
  color: white !important;
}
.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {
  background-color: #deb841 !important; /* Gold background for active button */
  color: black !important;
}


.rbc-today {
  background-color: rgba(206, 255, 26, 0.7 ) !important; /* #ceff1a  is the same as rgba(206, 255, 26, 0.5) */
}
.rbc-off-range-bg {
  background-color: rgba(111, 111, 111, 0.7) !important; /* light transparent gray */
}

/* Exercise Notes */
.exercise-notes {
  width: 100%;
  margin: 1rem 0;
}

.exercise-notes h4 {
  text-align: left;
  margin-bottom: 0.5rem;
}

.exercise-notes textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.9rem;
  resize: vertical;
}

.exercise-notes textarea:focus {
  outline: none;
  border-color: #1976d2;
}

/* Activity page styles */
.activity-queue-view {
  margin-top: 1rem;
}




.exercise.read-only {
  background-color: #f5f5f5;
  border-left: 5px solid #deb841;
  transition: background-color 0.2s;
  margin-bottom: 1rem;
  cursor: default;
}

.exercise.read-only:hover {
  background-color: #f0f0f0;
}

.exercise.read-only .exercise-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1rem;
}

.exercise.read-only .exercise-details {
  padding: 0 1rem 1rem 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.exercise.read-only .exercise-details p {
  margin: 0.25rem 0;
}

/* Dashboard styles */
/* .dashboard {
  background-color: #f9f9f9;
} */

.dashboard h1 {
  margin-bottom: 2rem;
}

.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background-color: rgba(0,0,0,0.4);
  color: white;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.stat-card h3 {
  font-size: 1rem;
  color: #aaa;
  margin-bottom: 0.5rem;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #7a70bc;
  margin: 0;
}

.dashboard-section {
  margin-bottom: 2rem;
}

.dashboard-section h2 {
  margin-bottom: 1rem;
  border-bottom: 2px solid #deb841;
  padding-bottom: 0.5rem;
  color: #2e275a;
}

.clients-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}


.client-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.client-card {
  background-color: rgba(0,0,0,0.4);
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.client-avatar {
  width: 50px;
  height: 50px;
  background-color: #deb841;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
}

.client-info {
  flex: 1 1;
}

.client-info h3 {
  margin: 0 0 0.5rem 0;
}

.client-info p {
  margin: 0.25rem 0.2rem;
  padding: 0.2rem 0.5rem;
  color: #aaa;
  font-size: 0.9rem;
}

.view-client-btn {
  background-color: #2e275a;
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.view-client-btn:hover {
  background-color: #3f2151;
}

.activity-feed {
  background-color: rgba(0,0,0,0.4);

  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

.activity-item {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid #eee;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  width: 10px;
  height: 10px;
  background-color: #deb841;
  border-radius: 50%;
  margin-top: 5px;
}

.activity-details {
  flex: 1 1;
}

.activity-details p {
  margin: 0;
}

.activity-time {
  color: #999;
  font-size: 0.85rem;
  margin-top: 0.25rem !important;
}

@media (max-width: 768px) {
  .dashboard-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .dashboard-stats {
    grid-template-columns: 1fr;
  }
}

/* Clients list page styles */
.clients-page h1 {
  margin-bottom: 2rem;
}

.clients-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
/* 
.search-filter {
  display: flex;
  gap: 1rem;
} */

.client-search,
.client-filter {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 0.9rem;
}
/* 
.client-search {
  width: 250px;
} */

.add-client-btn {
  background-color: #deb841;
  color: #000;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-client-btn:hover {
  background-color: #c9a539;
}

.clients-table-container {
  /* background-color: white; */
  background-color: rgba(0,0,0,0.3);
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.clients-table {
  width: 100%;
  border-collapse: collapse;
}

.clients-table th,
.clients-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.clients-table th {
  /* background-color: #f5f5f5; */
  background-color: rgba(0,0,0,0.3);
  font-weight: bold;
  color: #aaa;
}

.client-row:hover {
  /* background-color: #f9f9f9; */
  background-color: rgba(0,0,0,0.2);
}

.client-name {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.client-avatar-small {
  width: 30px;
  height: 30px;
  background-color: #deb841;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 0.85rem;
}

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.status-badge.active {
  background-color: #e6f7ee;
  color: #0e402d;
}

.status-badge.inactive {
  background-color: #f2f2f2;
  color: #666;
}

.status-badge.on-hold {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.completed {
  background-color: #cff4fc;
  color: #055160;
}

.view-client-btn-small {
  background-color: #2e275a;
  color: white;
  text-decoration: none;
  padding: 0.3rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  transition: background-color 0.2s;
}

.view-client-btn-small:hover {
  background-color: #3f2151;
}

@media (max-width: 768px) {
  .clients-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .search-filter {
    width: 100%;
  }
  
  .client-search {
    flex: 1 1;
  }
  
  .add-client-btn {
    width: 100%;
  }
  
  .clients-table {
    display: block;
  }
}

/* Client navigation styles */
.client-nav {
  list-style-type: none;
  padding: 0;
  margin: 1.0rem 0 0 0;
}

.client-nav li {
  margin-bottom: 0.5rem;
}

.client-nav a {
  display: block;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  color: #ccc;
  text-decoration: none;
  transition: 0.2s;
}

.client-nav a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.client-nav a.active {
  /* background-color: #deb841; */
  background-color: rgba(255, 255, 255, 0.08); 
  color: white;
  font-weight: bold;
}

/* Workout Library styles */
.workout-library-page h1 {
  margin-bottom: 2rem;
}

.library-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.workout-search,
.workout-filter {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 0.9rem;
}

/* .workout-search {
  width: 250px;
} */

.add-workout-btn {
  background-color: #deb841;
  color: #000;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.add-workout-btn:hover {
  background-color: #c9a539;
}

.workout-table-container {
  /* background-color: white; */
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.workout-table {
  width: 100%;
  border-collapse: collapse;
}

.workout-table th,
.workout-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #eee;
  background-color: rgba(0,0,0,0.3);
}

.workout-table th {
  background-color: rgba(0,0,0,0.5);
  font-weight: bold;
  color: #becb6a;
}

.workout-row:hover {
  background-color: #58204b;
}

.difficulty-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

.difficulty-badge.beginner {
  background-color: #e6f7ee;
  color: #0e402d;
}

.difficulty-badge.intermediate {
  background-color: #fff3cd;
  color: #856404;
}

.difficulty-badge.advanced {
  background-color: #f8d7da;
  color: #721c24;
}

.workout-actions {
  display: flex;
  gap: 0.5rem;
}

.view-workout-btn,
.edit-workout-btn {
  background-color: #2e275a;
  color: white;
  border: none;
  padding: 0.3rem 0.75rem;
  border-radius: 4px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.edit-workout-btn {
  background-color: #58204b;
}

.view-workout-btn:hover {
  background-color: #3f2151;
}

.edit-workout-btn:hover {
  background-color: #76286a;
}

@media (max-width: 768px) {
  .library-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .search-filter {
    width: 100%;
  }
  
  .workout-search {
    flex: 1 1;
  }
  
  .add-workout-btn {
    width: 100%;
  }
  
  .workout-table {
    display: block;
    overflow-x: auto;
  }
}

/* Profile Page Styles */
.profile-page h1 {
  margin-bottom: 1rem;
}

.profile-container {
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* padding: 2rem; */
  padding: 1rem 0rem; /* Vertical padding */
  max-width: 900px;
  margin: 0 auto;
}

.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  gap: 2rem;
}

.profile-image-container {
  position: relative;
}

.profile-image {
  width: 120px;
  height: 120px;
  background-color: #deb841;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  font-weight: bold;
  color: white;
}

.change-photo-btn {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2e275a;
  color: white;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
}

.profile-info {
  flex: 1 1;
}

.profile-name {
  font-size: 1.8rem;
  margin: 0 0 0.5rem 0;
}

.profile-title {
  font-size: 1.1rem;
  color: #cb82d2;
  margin: 0;
}

.profile-name-input,
.profile-title-input {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.profile-name-input {
  font-size: 1.5rem;
  font-weight: bold;
}

.edit-profile-btn {
  background-color: #2e275a;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  align-self: flex-start;
}

.profile-section {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}

.profile-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.profile-section h3 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: #bbb6de;
}

.bio-textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-family: inherit;
  resize: vertical;
}

.specialties-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.specialty-tag {
  background-color: #98bd9f;
  color: #1e3322;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.9rem;
}

.specialties-edit,
.certifications-edit {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.specialty-input-group,
.certification-input-group {
  display: flex;
  gap: 0.5rem;
}

.specialty-input-group input,
.certification-input-group input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.remove-btn {
  background-color: #f44336;
  color: white;
  border: none;
  width: 30px;
  border-radius: 4px;
  cursor: pointer;
}

.add-specialty-btn,
.add-certification-btn {
  background-color: #deb841;
  color: black;
  border: none;
  padding: 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  font-weight: bold;
  margin-top: 0.5rem;
}

.contact-edit {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
}

.contact-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contact-input-group label {
  font-weight: bold;
}

.contact-input-group input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.certifications-list li {
  margin-bottom: 0.5rem;
}

/* Settings Page Styles */
.settings-page h1 {
  margin-bottom: 1.5rem;
}

.settings-tabs, .settings-content {
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid #ddd;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 10px;
  padding: 1rem;
  max-width: 40vw;
}

.settings-tabs button {
  background: none;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  cursor: pointer;
  position: relative;
}

/* Do a hover  */
.settings-tabs button:hover {
  color: white !important;
  background-color: yellow !important;
  font-weight: bold;
}


.settings-tabs button.active {
  color: #2e275a;
  font-weight: bold;
}

.settings-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #deb841;
}

.subscription-container {
  max-width: 900px;
}

.current-plan-section {
  margin-bottom: 3rem;
}

.current-plan-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  gap: 2rem;
}

.plan-info {
  flex: 1 1;
}

.plan-info h3 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: #2e275a;
}

.plan-price {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.plan-price span {
  font-size: 1rem;
  font-weight: normal;
  color: #666;
}

.renewal-info {
  color: #666;
}

.payment-method {
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  min-width: 250px;
}

.payment-method h4 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.update-payment-btn {
  background-color: #2e275a;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 1rem;
}

.plans-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
}

.plan-card {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;
  transition: transform 0.3s, box-shadow 0.3s;
}

.plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.plan-card.popular {
  border-color: #deb841;
}

.plan-card.current {
  border-color: #2e275a;
}

.popular-badge,
.current-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  font-weight: bold;
  color: white;
}

.popular-badge {
  background-color: #deb841;
}

.current-badge {
  background-color: #2e275a;
}

.plan-card h3 {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #2e275a;
}

.plan-features {
  padding-left: 1.5rem;
  margin-bottom: 1.5rem;
}

.plan-features li {
  margin-bottom: 0.5rem;
}

.select-plan-btn,
.cancel-plan-btn {
  width: 100%;
  padding: 0.75rem 0;
  border: none;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}

.select-plan-btn {
  background-color: #deb841;
  color: #000;
}

.cancel-plan-btn {
  background-color: #f5f5f5;
  color: #666;
}

@media (max-width: 768px) {
  .profile-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
  }

  .settings-tabs {
    max-width: 100%
  }
  
  .edit-profile-btn {
    align-self: center;
  }
  
  .current-plan-card {
    flex-direction: column;
  }
  
}





/* Additions for ClientDashboard */
/* Client Dashboard */
.client-dashboard h1 {
  margin-bottom: 2rem;
  color: #2e275a;
}

.client-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.overview-card {
  background-color: white;
  border-radius: 10px;
  padding: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.overview-card h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #666;
}

.overview-card p {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
  color: #2e275a;
}

.goals-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.goals-list li {
  background-color: #fddc64; /* Soft gold */
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-weight: bold;
  color: #1c1c1e;
}

.progress-log {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.progress-log li {
  background-color: white;
  padding: 1rem;
  border-left: 5px solid #deb841;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  color: #2e275a;
}

/* Exercise Type Detail Page */
.exercise-detail-page {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  max-width: 600px;
  margin: 2rem auto;
  padding: 2rem 2.5rem;
  color: #2e275a;
}

.exercise-detail-page h1 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #58204b;
  font-size: 2rem;
}

.exercise-detail-page p {
  margin: 0.5rem 0 1rem 0;
  font-size: 1.1rem;
}

.exercise-detail-page strong {
  color: #3f2151;
}



.remove-exercise-btn {
  margin-left: auto;
  border: none;
  background: #ff3333;
  cursor: pointer;
  float: right;
  font-size: 2rem;
  border-radius: 20%;
}

.add-exercise-btn {
  background-color: #deb841; /* Gold background */
  color: black;
  border: none;
  padding: 0.75rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: background-color 0.2s;
}


.alert-info {
  background-color: #f0f8ff; /* Light blue background */
  color: #2e275a; /* Dark blue text */
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}


.delete-account-btn {
  background-color: #ff3333; /* Red background */
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}


.trainer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.trainer-search-blurb-container {
  padding: 2rem;
  margin: 2rem 0rem;
  background-color: rgba(0,0,0,0.3);
}


.chevron {
  float: right;
}











@keyframes getting-started-pulse {
  0% { transform: scale(1); 
    opacity: 1; 
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.6); }
  50% { transform: scale(1.05); opacity: 0.9;
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% { transform: scale(1); opacity: 1;
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }

}


/* Fogged glass effect for dashboard cards */
.fogged-card {
  /* background: rgba(40, 40, 60, 0.35); */
  border-radius: 12px;
  /* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  /* border: 1px solid rgba(255, 255, 255, 0.18); */
  /* color: white; */
}



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;CAQC;AACD;EACE,cAAc;AAChB;AACA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,cAAc;AAChB;;;AAGA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;;;AAGA;;;;;;;;;;CAUC;AACD;;;;;GAKG;;;AAGH,iBAAiB;AACjB;EACE,SAAS;EACT,+CAA+C;;EAE/C,uEAAuE;EACvE,kFAAkF;EAClF,0EAA0E;;EAE1E,kFAAkF;;EAElF,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,yBAAyB;AACzC;;AAEA,yBAAyB;AACzB;EACE,2BAA2B;EAC3B,cAAc;EACd,mDAAmD;EACnD,qBAAqB;AACvB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;;AAGA,iBAAiB;AACjB;EACE,WAAW;EACX,SAAO;EACP,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,UAAU,yBAAyB,EAAE,EAAE,iBAAiB;AACxD,UAAU,yBAAyB,EAAE,EAAE,aAAa;AACpD,UAAU,yBAAyB,EAAE,EAAE,sBAAsB;AAC7D,UAAU,yBAAyB,EAAE,EAAE,sBAAsB;AAC7D,UAAU,yBAAyB,EAAE,EAAE,sBAAsB;;AAE7D,kBAAkB;AAClB;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;;AAGA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;;AAEnC;AACA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA,UAAU,yBAAyB,EAAE;AACrC,SAAS,yBAAyB,EAAE;AACpC,UAAU,yBAAyB,EAAE;;AAErC,oBAAoB;AACpB;EACE,yBAAyB,EAAE,4BAA4B;EACvD,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,YAAY,EAAE,eAAe;EAC7B,eAAe,EAAE,eAAe;AAClC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB,EAAE,kCAAkC;EACtD,WAAW,EAAE,qBAAqB;EAClC,aAAa,EAAE,uBAAuB;EACtC,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB,EAAE,8BAA8B;EACjD,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;AACrD;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,iBAAiB,EAAE,cAAc;AACnC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;;EAET,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB,EAAE,0BAA0B;AACnD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,WAAW,EAAE,0CAA0C;EACvD,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;EACtD,YAAY;EACZ,eAAe,EAAE,2BAA2B;EAC5C,mBAAmB;EACnB,wCAAwC;EACxC,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B,EAAE,mCAAmC;EACnE,+BAA+B;AACjC;;AAEA;EACE;IACE,cAAc,EAAE,mCAAmC;IACnD,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB,EAAE,+BAA+B;EAClD,iBAAiB;;EAEjB,qBAAqB,EAAE,kBAAkB;AAC3C;;AAEA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;;;EAGjB,eAAe;EACf,iCAAiC;AACnC;;;AAGA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;;AAEA;EACE,iBAAiB,EAAE,cAAc;AACnC;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB,EAAE,QAAQ;EACnC,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,uCAAuC;AACvC;EACE,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC,EAAE,sCAAsC;EAC5E,uBAAuB;AACzB;;;AAGA;EACE,qDAAqD,EAAE,oDAAoD;AAC7G;AACA;EACE,qDAAqD,EAAE,2BAA2B;AACpF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;;;;AAKA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;;EAEjC,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;;GAIG;;AAEH;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;;GAGG;;AAEH;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB,EAAE,qBAAqB;EACzC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,SAAO;EACP,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;AACnB;;;AAGA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE;EACF;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;AAEF;;;;;;AAMA,kCAAkC;AAClC,qBAAqB;AACrB;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iCAAiC;AACnC;;;AAGA;EACE,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,mBAAmB;EACnC,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,yBAAyB,EAAE,mBAAmB;EAC9C,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,iCAAiC;AACnC;;;AAGA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;;AAGA;EACE,YAAY;AACd;;;;;;;;;;;;AAYA;EACE,KAAK,mBAAmB;IACtB,UAAU;IACV,0CAA0C,EAAE;EAC9C,MAAM,sBAAsB,EAAE,YAAY;IACxC,2CAA2C,EAAE;EAC/C,OAAO,mBAAmB,EAAE,UAAU;IACpC,wCAAwC,EAAE;;AAE9C;;;AAGA,4CAA4C;AAC5C;EACE,wCAAwC;EACxC,mBAAmB;EACnB,sDAAsD;EACtD,0BAA0B;EAC1B,kCAAkC;EAClC,iDAAiD;EACjD,kBAAkB;AACpB","sourcesContent":["/*\nBackground: #0b0b0c\nIconography and buttons: #42bbd8\nTitle: #d1d0d1\nHeaders: #cccdcd\nText: #cdccca \nCard backgrounds: #161717\n\n*/\n.ptc-h {\n  color: #cccdcd;\n}\n/* .ptc-card {\n  background-color: #161717;\n  color: #cdccca\n} */\n\n.ptc-button {\n  background-color: #42bbd8;\n  color: black;\n  font-weight: bold;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.ptc-secondary-button {\n  background-color: #777;\n  color: #111;\n  font-weight: bold;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\na {\n  color: #42bbd8;\n}\n\n\nh1, h2, h3, h4 {\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n  color: #cccdcd;\n}\n\n\n/*\nOLD (up to september 4 2025) Color Palette:\n  Violet: #58204b\n  Russian Violet: #3f2151\n  Cambridge Blue: #8ab0ab\n  Dark green: #0e402d\n  Gold: #deb841\n  Auburn (Red): #9e2a35\n  Lime: #ceff1a\n\n*/\n/* \n\nThis is too devy:\nh1, h2, h3, h4 {\n  font-family:'Courier New', Courier, monospace\n} */\n\n\n/* Reset layout */\nbody {\n  margin: 0;\n  /* font-family: 'Helvetica Neue', sans-serif; */\n\n  /* Lets make a really cool font family for this personal trainers app */\n  /* font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif; */\n  /* font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif; */\n\n  /* font-family: 'IBM Plex Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif; */\n\n  background-color: #b88080;\n  /* color: #1c1c1e; */\n  color: #bab7d0;\n}\n\n.container {\n  display: flex;\n  /* min-height: 100%; */\n}\n\n.text-dark {\n  color: black !important;\n}\n\n.spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%; /* Full viewport height */\n}\n\n/* Sidebar bottom links */\n.nav-link-sidebar-bottom {\n  margin-top: auto !important;\n  display: block;\n  /* Optional: add a little spacing from the bottom */\n  margin-bottom: 0.5rem;\n}\n\n/* Ensure sidebar uses flex column for proper alignment */\n.sidebar .client-nav {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n\n/* Main Content */\n.main {\n  width: 100%;\n  flex: 1;\n  /* padding: 2rem; */\n  /* padding-top: 6rem; */\n}\n\n\n.goal-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.goal-item {\n  padding: 1rem;\n  border-radius: 10px;\n  font-weight: bold;\n  font-size: 1.1rem;\n  color: #1c1c1e;\n}\n\n.goal-0 { background-color: #f78b82; } /* Build Muscle */\n.goal-1 { background-color: #fddc64; } /* Lose Fat */\n.goal-2 { background-color: #3ec6c0; } /* Improve Endurance */\n.goal-3 { background-color: #c7a8f3; } /* Increase Strength */\n.goal-4 { background-color: #f7a864; } /* Increase Mobility */\n\n/* Output layout */\n.output {\n  /* margin-top: 2rem; */\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  color: rgb(153, 170, 255);\n  background-color: rgba(0,0,0,0.3);\n  border-radius: 10px;\n  padding: 1.5rem 0.5rem;\n  margin: 1.5rem 0;\n}\n\n.day {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n\n.calendar-day {\n  background-color: #b5eec3; /* Olive green background */\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.copy-link {\n  background-color: #8ab0ab; /* Cambridge Blue background */\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: bold;\n  display: inline-block;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.get-google-sheet-export {\n  background-color: #3f2151; /*  background */\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  font-weight: bold;\n  display: inline-block;\n  cursor: pointer;\n  transition: background-color 0.2s;\n\n}\n.exercise {\n  background-color: #8ab0ab; /* Cambridge Blue background */\n  padding: 0.5rem 1rem;\n  margin: 0.2rem 0rem;\n  border-radius: 8px;\n  font-weight: bold;\n  display: inline-block;\n  width: 100%;\n}\n\n.yellow { background-color: #fddc64; }\n.green { background-color: #b5eec3; }\n.red    { background-color: #f78b82; }\n\n/* Weaknesses Card */\n.weakness {\n  background-color: #9E2A35; /* Auburn (red) background */\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* One-rep max input group */\n.one-rep-max {\n  background-color: #0e402d; /* Evergreen color */\n  color: white;\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.one-rep-max input[type=\"number\"],\n.one-rep-max select {\n  height: 120%; /* 20% bigger */\n  font-size: 110%; /* 10% bigger */\n}\n\n/* Availability Slot */\n.availability-slot {\n  background-color: #8ab0ab; /* Blue background */\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  position: relative; /* Enable positioning within the slot */\n}\n\n.availability-slot h2 {\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.availability-slot select,\n.availability-slot input[type=\"text\"],\n.availability-slot input[type=\"number\"] {\n  height: 2.5rem;\n  font-size: 1rem;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.availability-slot select:focus,\n.availability-slot input[type=\"text\"]:focus,\n.availability-slot input[type=\"number\"]:focus {\n  outline: none;\n  border-color: #1976d2; /* Darker blue for focus */\n}\n\n.availability-slot p{\n  margin: 0;\n}\n\n.availability-slot .delete-slot {\n  position: absolute; /* Position relative to the slot */\n  top: 0.5rem; /* Close to the top */\n  right: 0.5rem; /* Close to the right */\n  background-color: #9e2a35; /* Red background */\n  color: white;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 5px;\n  font-size: 0.8rem; /* Slightly larger font size */\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.availability-slot .delete-slot:hover {\n  background-color: #9e2a35; /* Darker red on hover */\n}\n\n/* Add Another Button */\nbutton.add-another {\n  width: 100%;\n  background-color: #ceff1a; /* Lime background */\n  border: none;\n  padding: 0.75rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\nbutton.add-another:hover {\n  background-color: #0e402d; /* Slightly darker green on hover */\n}\n\nbutton.add-another .icon {\n  font-size: 1.2rem; /* Icon size */\n}\n\n/* Workout Preferences */\n.workout-preferences {\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n\n  /* mint green muted  */\n  padding: 1.5rem;\n}\n\n.workout-preferences input {\n  height: 2.5rem;\n  font-size: 1rem;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n/* Workout Selector */\n.workout-selector {\n  height: 2.5rem;\n  font-size: 1rem;\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  width: 100%;\n  margin-bottom: 1rem;\n}\n\n.workout-selector:focus {\n  outline: none;\n  border-color: #1976d2; /* Darker blue for focus */\n}\n\n/* Week Calendar */\n.week-calendar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem; /* Reduce gap further for tighter layout */\n  margin-top: 1rem; /* Add margin to push day blocks down */\n}\n\n.day-block {\n  background-color: #b5eec3; /* Olive green background */\n  color: black;\n  padding: 0.5rem; /* Reduce padding further */\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  flex: 1 1 calc(20.2% - 0.5rem); /* Adjust width for seven columns */\n  max-width: calc(20.2% - 0.5rem);\n}\n\n@media (max-width: 768px) {\n  .day-block {\n    flex: 1 1 100%; /* Full width for smaller screens */\n    max-width: 100%;\n  }\n}\n\n.day-block h3 {\n  font-size: 0.9rem; /* Slightly smaller font size */\n  font-weight: bold;\n  \n  margin-bottom: 0.3rem; /* Reduce margin */\n}\n\n.availability-slot button.delete-slot {\n  background-color: #9e2a35; /* Red background */\n  color: white;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 5px;\n  font-size: 0.5rem;\n\n  \n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n\n.card {\n  /* background-color: #ffffff; */\n  padding: 1rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 1rem;\n}\n\nbutton.add-slot {\n  width: 100%;\n  background-color: #ceff1a; /* Green background */\n  color: black;\n  border: none;\n  padding: 0.75rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\nbutton.add-slot:hover {\n  background-color: #0e402d; /* Slightly darker green on hover */\n}\n\nbutton.add-slot .icon {\n  font-size: 1.2rem; /* Icon size */\n}\n\n/* Guided View Styles */\n.guided-view {\n  background-color: rgba(0,0,0,0.4);\n  color: white;\n  border-radius: 12px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n  padding: 2rem;\n  text-align: center;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.guided-view .quote {\n  font-style: italic;\n  font-size: 1.2rem;\n  color: #666;\n  margin: 2rem 0;\n}\n\n.guided-view .start-button {\n  background-color: #deb841; /* Gold background */\n  color: black;\n  font-weight: bold;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 8px;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.guided-view .start-button:hover {\n  background-color: #c9a539;\n}\n\n.exercise-card {\n  background-color: #fff;\n  border-radius: 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.exercise-image img {\n  border-radius: 8px;\n  max-width: 100%;\n}\n\n.exercise-details {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.1rem;\n  width: 100%;\n  text-align: left;\n}\n\n.exercise-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.complete-button, .failed-button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.complete-button {\n  background-color: #4caf50; /* Green */\n  color: white;\n}\n\n.complete-button:hover {\n  background-color: #3e8e41;\n}\n\n.failed-button {\n  background-color: #f44336; /* Red */\n  color: white;\n}\n\n.failed-button:hover {\n  background-color: #d32f2f;\n}\n\n.completion h1 {\n  color: #4caf50;\n  margin-bottom: 1.5rem;\n}\n\n/* View switch styles */\n.view-switch {\n  display: flex;\n  gap: 1.5rem;\n  /* margin-bottom: 2rem; */\n  /* background-color: #f5f5f5; */\n  padding: 1rem;\n  border-radius: 8px;\n}\n\n.view-switch label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n}\n\n.view-switch input[type=\"radio\"] {\n  cursor: pointer;\n}\n\n/* Modifies react-big-calendar styles */\n.calendar-container {\n  color: white; \n}\n.rbc-toolbar button {\n  color: white !important;\n}\n.rbc-toolbar button:active, .rbc-toolbar button.rbc-active {\n  background-color: #deb841 !important; /* Gold background for active button */\n  color: black !important;\n}\n\n\n.rbc-today {\n  background-color: rgba(206, 255, 26, 0.7 ) !important; /* #ceff1a  is the same as rgba(206, 255, 26, 0.5) */\n}\n.rbc-off-range-bg {\n  background-color: rgba(111, 111, 111, 0.7) !important; /* light transparent gray */\n}\n\n/* Exercise Notes */\n.exercise-notes {\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.exercise-notes h4 {\n  text-align: left;\n  margin-bottom: 0.5rem;\n}\n\n.exercise-notes textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 0.9rem;\n  resize: vertical;\n}\n\n.exercise-notes textarea:focus {\n  outline: none;\n  border-color: #1976d2;\n}\n\n/* Activity page styles */\n.activity-queue-view {\n  margin-top: 1rem;\n}\n\n\n\n\n.exercise.read-only {\n  background-color: #f5f5f5;\n  border-left: 5px solid #deb841;\n  transition: background-color 0.2s;\n  margin-bottom: 1rem;\n  cursor: default;\n}\n\n.exercise.read-only:hover {\n  background-color: #f0f0f0;\n}\n\n.exercise.read-only .exercise-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 1rem;\n}\n\n.exercise.read-only .exercise-details {\n  padding: 0 1rem 1rem 1rem;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.5rem;\n}\n\n.exercise.read-only .exercise-details p {\n  margin: 0.25rem 0;\n}\n\n/* Dashboard styles */\n/* .dashboard {\n  background-color: #f9f9f9;\n} */\n\n.dashboard h1 {\n  margin-bottom: 2rem;\n}\n\n.dashboard-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background-color: rgba(0,0,0,0.4);\n  color: white;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.stat-card h3 {\n  font-size: 1rem;\n  color: #aaa;\n  margin-bottom: 0.5rem;\n}\n\n.stat-number {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #7a70bc;\n  margin: 0;\n}\n\n.dashboard-section {\n  margin-bottom: 2rem;\n}\n\n.dashboard-section h2 {\n  margin-bottom: 1rem;\n  border-bottom: 2px solid #deb841;\n  padding-bottom: 0.5rem;\n  color: #2e275a;\n}\n\n.clients-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n\n.client-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.client-card {\n  background-color: rgba(0,0,0,0.4);\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.client-avatar {\n  width: 50px;\n  height: 50px;\n  background-color: #deb841;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: white;\n}\n\n.client-info {\n  flex: 1;\n}\n\n.client-info h3 {\n  margin: 0 0 0.5rem 0;\n}\n\n.client-info p {\n  margin: 0.25rem 0.2rem;\n  padding: 0.2rem 0.5rem;\n  color: #aaa;\n  font-size: 0.9rem;\n}\n\n.view-client-btn {\n  background-color: #2e275a;\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  transition: background-color 0.2s;\n}\n\n.view-client-btn:hover {\n  background-color: #3f2151;\n}\n\n.activity-feed {\n  background-color: rgba(0,0,0,0.4);\n\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n}\n\n.activity-item {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  border-bottom: 1px solid #eee;\n}\n\n.activity-item:last-child {\n  border-bottom: none;\n}\n\n.activity-icon {\n  width: 10px;\n  height: 10px;\n  background-color: #deb841;\n  border-radius: 50%;\n  margin-top: 5px;\n}\n\n.activity-details {\n  flex: 1;\n}\n\n.activity-details p {\n  margin: 0;\n}\n\n.activity-time {\n  color: #999;\n  font-size: 0.85rem;\n  margin-top: 0.25rem !important;\n}\n\n@media (max-width: 768px) {\n  .dashboard-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-stats {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Clients list page styles */\n.clients-page h1 {\n  margin-bottom: 2rem;\n}\n\n.clients-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n/* \n.search-filter {\n  display: flex;\n  gap: 1rem;\n} */\n\n.client-search,\n.client-filter {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 0.9rem;\n}\n/* \n.client-search {\n  width: 250px;\n} */\n\n.add-client-btn {\n  background-color: #deb841;\n  color: #000;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-client-btn:hover {\n  background-color: #c9a539;\n}\n\n.clients-table-container {\n  /* background-color: white; */\n  background-color: rgba(0,0,0,0.3);\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.clients-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.clients-table th,\n.clients-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n}\n\n.clients-table th {\n  /* background-color: #f5f5f5; */\n  background-color: rgba(0,0,0,0.3);\n  font-weight: bold;\n  color: #aaa;\n}\n\n.client-row:hover {\n  /* background-color: #f9f9f9; */\n  background-color: rgba(0,0,0,0.2);\n}\n\n.client-name {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.client-avatar-small {\n  width: 30px;\n  height: 30px;\n  background-color: #deb841;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: white;\n  font-size: 0.85rem;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.status-badge.active {\n  background-color: #e6f7ee;\n  color: #0e402d;\n}\n\n.status-badge.inactive {\n  background-color: #f2f2f2;\n  color: #666;\n}\n\n.status-badge.on-hold {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.status-badge.completed {\n  background-color: #cff4fc;\n  color: #055160;\n}\n\n.view-client-btn-small {\n  background-color: #2e275a;\n  color: white;\n  text-decoration: none;\n  padding: 0.3rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  transition: background-color 0.2s;\n}\n\n.view-client-btn-small:hover {\n  background-color: #3f2151;\n}\n\n@media (max-width: 768px) {\n  .clients-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  \n  .search-filter {\n    width: 100%;\n  }\n  \n  .client-search {\n    flex: 1;\n  }\n  \n  .add-client-btn {\n    width: 100%;\n  }\n  \n  .clients-table {\n    display: block;\n  }\n}\n\n/* Client navigation styles */\n.client-nav {\n  list-style-type: none;\n  padding: 0;\n  margin: 1.0rem 0 0 0;\n}\n\n.client-nav li {\n  margin-bottom: 0.5rem;\n}\n\n.client-nav a {\n  display: block;\n  padding: 0.5rem 1rem;\n  border-radius: 10px;\n  color: #ccc;\n  text-decoration: none;\n  transition: 0.2s;\n}\n\n.client-nav a:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.client-nav a.active {\n  /* background-color: #deb841; */\n  background-color: rgba(255, 255, 255, 0.08); \n  color: white;\n  font-weight: bold;\n}\n\n/* Workout Library styles */\n.workout-library-page h1 {\n  margin-bottom: 2rem;\n}\n\n.library-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.workout-search,\n.workout-filter {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 0.9rem;\n}\n\n/* .workout-search {\n  width: 250px;\n} */\n\n.add-workout-btn {\n  background-color: #deb841;\n  color: #000;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.add-workout-btn:hover {\n  background-color: #c9a539;\n}\n\n.workout-table-container {\n  /* background-color: white; */\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.workout-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.workout-table th,\n.workout-table td {\n  padding: 1rem;\n  text-align: left;\n  border-bottom: 1px solid #eee;\n  background-color: rgba(0,0,0,0.3);\n}\n\n.workout-table th {\n  background-color: rgba(0,0,0,0.5);\n  font-weight: bold;\n  color: #becb6a;\n}\n\n.workout-row:hover {\n  background-color: #58204b;\n}\n\n.difficulty-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.difficulty-badge.beginner {\n  background-color: #e6f7ee;\n  color: #0e402d;\n}\n\n.difficulty-badge.intermediate {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n.difficulty-badge.advanced {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n.workout-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.view-workout-btn,\n.edit-workout-btn {\n  background-color: #2e275a;\n  color: white;\n  border: none;\n  padding: 0.3rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.edit-workout-btn {\n  background-color: #58204b;\n}\n\n.view-workout-btn:hover {\n  background-color: #3f2151;\n}\n\n.edit-workout-btn:hover {\n  background-color: #76286a;\n}\n\n@media (max-width: 768px) {\n  .library-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n  \n  .search-filter {\n    width: 100%;\n  }\n  \n  .workout-search {\n    flex: 1;\n  }\n  \n  .add-workout-btn {\n    width: 100%;\n  }\n  \n  .workout-table {\n    display: block;\n    overflow-x: auto;\n  }\n}\n\n/* Profile Page Styles */\n.profile-page h1 {\n  margin-bottom: 1rem;\n}\n\n.profile-container {\n  background-color: rgba(0, 0, 0, 0.4);\n  color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  /* padding: 2rem; */\n  padding: 1rem 0rem; /* Vertical padding */\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.profile-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 2rem;\n}\n\n.profile-image-container {\n  position: relative;\n}\n\n.profile-image {\n  width: 120px;\n  height: 120px;\n  background-color: #deb841;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 3rem;\n  font-weight: bold;\n  color: white;\n}\n\n.change-photo-btn {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #2e275a;\n  color: white;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n}\n\n.profile-info {\n  flex: 1;\n}\n\n.profile-name {\n  font-size: 1.8rem;\n  margin: 0 0 0.5rem 0;\n}\n\n.profile-title {\n  font-size: 1.1rem;\n  color: #cb82d2;\n  margin: 0;\n}\n\n.profile-name-input,\n.profile-title-input {\n  width: 100%;\n  padding: 0.5rem;\n  margin-bottom: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.profile-name-input {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.edit-profile-btn {\n  background-color: #2e275a;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  align-self: flex-start;\n}\n\n.profile-section {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #eee;\n}\n\n.profile-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  padding-bottom: 0;\n}\n\n.profile-section h3 {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  color: #bbb6de;\n}\n\n.bio-textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-family: inherit;\n  resize: vertical;\n}\n\n.specialties-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.specialty-tag {\n  background-color: #98bd9f;\n  color: #1e3322;\n  padding: 0.5rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n}\n\n.specialties-edit,\n.certifications-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.specialty-input-group,\n.certification-input-group {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.specialty-input-group input,\n.certification-input-group input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.remove-btn {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  width: 30px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.add-specialty-btn,\n.add-certification-btn {\n  background-color: #deb841;\n  color: black;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  align-self: flex-start;\n  font-weight: bold;\n  margin-top: 0.5rem;\n}\n\n.contact-edit {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1rem;\n}\n\n.contact-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.contact-input-group label {\n  font-weight: bold;\n}\n\n.contact-input-group input {\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.certifications-list li {\n  margin-bottom: 0.5rem;\n}\n\n/* Settings Page Styles */\n.settings-page h1 {\n  margin-bottom: 1.5rem;\n}\n\n.settings-tabs, .settings-content {\n  display: flex;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #ddd;\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 10px;\n  padding: 1rem;\n  max-width: 40vw;\n}\n\n.settings-tabs button {\n  background: none;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  position: relative;\n}\n\n/* Do a hover  */\n.settings-tabs button:hover {\n  color: white !important;\n  background-color: yellow !important;\n  font-weight: bold;\n}\n\n\n.settings-tabs button.active {\n  color: #2e275a;\n  font-weight: bold;\n}\n\n.settings-tabs button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #deb841;\n}\n\n.subscription-container {\n  max-width: 900px;\n}\n\n.current-plan-section {\n  margin-bottom: 3rem;\n}\n\n.current-plan-card {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  display: flex;\n  gap: 2rem;\n}\n\n.plan-info {\n  flex: 1;\n}\n\n.plan-info h3 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  color: #2e275a;\n}\n\n.plan-price {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n\n.plan-price span {\n  font-size: 1rem;\n  font-weight: normal;\n  color: #666;\n}\n\n.renewal-info {\n  color: #666;\n}\n\n.payment-method {\n  padding: 1rem;\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  min-width: 250px;\n}\n\n.payment-method h4 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\n.update-payment-btn {\n  background-color: #2e275a;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.plans-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.plan-card {\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  position: relative;\n  overflow: hidden;\n  border: 2px solid transparent;\n  transition: transform 0.3s, box-shadow 0.3s;\n}\n\n.plan-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.plan-card.popular {\n  border-color: #deb841;\n}\n\n.plan-card.current {\n  border-color: #2e275a;\n}\n\n.popular-badge,\n.current-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0.25rem 1rem;\n  font-size: 0.75rem;\n  font-weight: bold;\n  color: white;\n}\n\n.popular-badge {\n  background-color: #deb841;\n}\n\n.current-badge {\n  background-color: #2e275a;\n}\n\n.plan-card h3 {\n  margin-top: 0.5rem;\n  margin-bottom: 1rem;\n  color: #2e275a;\n}\n\n.plan-features {\n  padding-left: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.plan-features li {\n  margin-bottom: 0.5rem;\n}\n\n.select-plan-btn,\n.cancel-plan-btn {\n  width: 100%;\n  padding: 0.75rem 0;\n  border: none;\n  border-radius: 5px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.select-plan-btn {\n  background-color: #deb841;\n  color: #000;\n}\n\n.cancel-plan-btn {\n  background-color: #f5f5f5;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .profile-header {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n  }\n\n  .settings-tabs {\n    max-width: 100%\n  }\n  \n  .edit-profile-btn {\n    align-self: center;\n  }\n  \n  .current-plan-card {\n    flex-direction: column;\n  }\n  \n}\n\n\n\n\n\n/* Additions for ClientDashboard */\n/* Client Dashboard */\n.client-dashboard h1 {\n  margin-bottom: 2rem;\n  color: #2e275a;\n}\n\n.client-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.overview-card {\n  background-color: white;\n  border-radius: 10px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.overview-card h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: #666;\n}\n\n.overview-card p {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #2e275a;\n}\n\n.goals-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.goals-list li {\n  background-color: #fddc64; /* Soft gold */\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-weight: bold;\n  color: #1c1c1e;\n}\n\n.progress-log {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.progress-log li {\n  background-color: white;\n  padding: 1rem;\n  border-left: 5px solid #deb841;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.05);\n  color: #2e275a;\n}\n\n/* Exercise Type Detail Page */\n.exercise-detail-page {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.08);\n  max-width: 600px;\n  margin: 2rem auto;\n  padding: 2rem 2.5rem;\n  color: #2e275a;\n}\n\n.exercise-detail-page h1 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n  color: #58204b;\n  font-size: 2rem;\n}\n\n.exercise-detail-page p {\n  margin: 0.5rem 0 1rem 0;\n  font-size: 1.1rem;\n}\n\n.exercise-detail-page strong {\n  color: #3f2151;\n}\n\n\n\n.remove-exercise-btn {\n  margin-left: auto;\n  border: none;\n  background: #ff3333;\n  cursor: pointer;\n  float: right;\n  font-size: 2rem;\n  border-radius: 20%;\n}\n\n.add-exercise-btn {\n  background-color: #deb841; /* Gold background */\n  color: black;\n  border: none;\n  padding: 0.75rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n\n.alert-info {\n  background-color: #f0f8ff; /* Light blue background */\n  color: #2e275a; /* Dark blue text */\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n\n.delete-account-btn {\n  background-color: #ff3333; /* Red background */\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n\n.trainer-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.trainer-search-blurb-container {\n  padding: 2rem;\n  margin: 2rem 0rem;\n  background-color: rgba(0,0,0,0.3);\n}\n\n\n.chevron {\n  float: right;\n}\n\n\n\n\n\n\n\n\n\n\n\n@keyframes getting-started-pulse {\n  0% { transform: scale(1); \n    opacity: 1; \n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.6); }\n  50% { transform: scale(1.05); opacity: 0.9;\n    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }\n  100% { transform: scale(1); opacity: 1;\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }\n\n}\n\n\n/* Fogged glass effect for dashboard cards */\n.fogged-card {\n  /* background: rgba(40, 40, 60, 0.35); */\n  border-radius: 12px;\n  /* box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); */\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  /* border: 1px solid rgba(255, 255, 255, 0.18); */\n  /* color: white; */\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
